module.exports = __webpack_public_path__ + "static/media/left-top.399b3999.svg";